module.exports = __webpack_public_path__ + "img/img-card-1.3c93f731.png";